import React from 'react';
import { FaChartLine, FaCalendarAlt, FaChevronRight } from 'react-icons/fa';

const TestResultsModal = ({ isOpen, onClose, results }) => {
  if (!isOpen || !results) return null;

  return (
    <div className="test-results-modal fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4">
      <div className="test-results-modal__content bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto relative">
        {/* Decorative element */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-400 via-primary to-purple-400 rounded-t-xl"></div>
        
        {/* Header with gradient background */}
        <div className="test-results-modal__header px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-white">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="test-results-modal__icon-wrapper bg-primary bg-opacity-10 p-3 rounded-full mr-4">
                <FaChartLine className="text-primary text-xl" />
              </div>
              <h2 className="test-results-modal__title text-2xl font-bold text-gray-800">{results.testName} Results</h2>
            </div>
            <button 
              className="test-results-modal__close-button text-gray-400 hover:text-gray-600 transition-colors"
              onClick={onClose}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        
        <div className="test-results-modal__body p-6">
          {/* Date information */}
          <div className="test-results-modal__metadata bg-gray-50 rounded-lg p-4 mb-6 border border-gray-100">
            <div className="flex items-center">
              <FaCalendarAlt className="text-gray-500 mr-2" />
              <span className="text-sm text-gray-600">
                <strong className="font-medium">Test Date:</strong> {new Date(results.endTime).toLocaleDateString()}
              </span>
            </div>
          </div>
          
          <div className="test-results-modal__content rounded-lg border border-gray-100 p-6 bg-white shadow-sm">
            <div className="test-results-modal__content-header border-b border-gray-200 pb-4 mb-6">
              <h3 className="text-xl font-semibold text-primary">Your Assessment Results</h3>
              <p className="text-sm text-gray-500 mt-1">The following results show your performance across different categories</p>
            </div>
            
            <div className="test-results-modal__categories space-y-6">
              {results.categoryResults && results.categoryResults.map((category, index) => (
                <div key={index} className="test-results-modal__category bg-blue-50 rounded-lg p-5 border border-blue-100">
                  <div className="flex justify-between items-center mb-3">
                    <h4 className="test-results-modal__category-name text-lg font-semibold text-gray-800">
                      {category.categoryName}
                    </h4>
                    <span className="test-results-modal__category-score text-primary font-bold bg-blue-100 py-1 px-3 rounded-full">
                      {category.score}/{category.maxScore}
                    </span>
                  </div>
                  
                  <div className="test-results-modal__category-progress mb-4">
                    <div className="w-full bg-white rounded-full h-3 border border-gray-100">
                      <div 
                        className="bg-gradient-to-r from-blue-400 to-primary h-3 rounded-full" 
                        style={{ width: `${(category.score / category.maxScore) * 100}%` }}
                      ></div>
                    </div>
                  </div>
                  
                  <p className="test-results-modal__category-description text-gray-700">
                    {category.description}
                  </p>
                </div>
              ))}
            </div>
            
            <div className="test-results-modal__content-footer border-t border-gray-200 pt-4 mt-6 text-sm text-gray-500 italic">
              <p>These results reflect your responses to the assessment questions. Consider exploring the detailed report for more in-depth insights.</p>
            </div>
          </div>
        </div>
        
        <div className="test-results-modal__footer px-6 py-4 border-t border-gray-200 flex justify-end">
          <button 
            className="test-results-modal__close-button flex items-center px-6 py-2.5 bg-primary text-white rounded-lg hover:bg-blue-600 transition-colors"
            onClick={onClose}
          >
            Close Results <FaChevronRight className="ml-2" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestResultsModal; 